// TEMPL: loads the subscription free-gift cart logic.
//
// The URL comes from window.TEMPL_GIFT_SRC, set by
// snippets/templ-subscription-gift.liquid (rendered from
// snippets/stylesheets.liquid). Read that snippet's comment before changing
// any of this — the indirection is not decorative, it is working around two
// separate problems at once:
//
//   1. a relative import produces a versionless URL, and Shopify's CDN pins
//      those to their first build, so edits stop reaching the storefront;
//   2. a module script tag in stylesheets.liquid renders BEFORE the theme's
//      import map, so '@shopify/events' fails to resolve and the file is
//      fetched but never executed.
//
// This file is the first element after the import map, so importing from here
// resolves correctly, and the URL carries a ?v= content hash so edits land.
if (window.TEMPL_GIFT_SRC) {
  import(window.TEMPL_GIFT_SRC).catch((error) => {
    // Presentation on the PDP still promises the gift, so make the failure
    // loud in the console rather than swallowing it.
    console.warn('[templ-gift] failed to load', error);
  });
} else {
  console.warn('[templ-gift] window.TEMPL_GIFT_SRC is not set — snippets/templ-subscription-gift.liquid is not rendering');
}

/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
